@if (footerContentHtml) {
<footer
  [innerHTML]="footerContentHtml | sanitizeHtml"
  id="ups-footer-wrap"
  class="ups-component ups-footer-container hpps-basic"
></footer>
}
